import { SonosSpeaker } from '../../services/sonosApi';

export function getSonosCardMarqueeParts(speaker: SonosSpeaker): {
  prefix: string;
  title: string | null;
} {
  const prefix = [speaker.current_artist, speaker.current_album].filter(Boolean).join(' · ');
  const title = speaker.current_title?.trim() || null;
  return { prefix, title };
}

export function getSonosCardMarqueeText(speaker: SonosSpeaker): string {
  const { prefix, title } = getSonosCardMarqueeParts(speaker);
  const parts = [prefix, title].filter(Boolean);
  return parts.join(' · ') || ' ';
}
